import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { DropRequestKpi } from "@/actions/ssr/scheduling/getDropRequestsSSR";
import type { SwapRequestKpi } from "@/actions/ssr/scheduling/getSwapRequestsSSR";

interface SchedulingDropSwapKpiState {
  drop: DropRequestKpi;
  swap: SwapRequestKpi;
}

const ZERO_KPI = {
  total_count: 0,
  pending_count: 0,
  approved_count: 0,
  rejected_count: 0,
};

const initialState: SchedulingDropSwapKpiState = {
  drop: { ...ZERO_KPI },
  swap: { ...ZERO_KPI },
};

const schedulingDropSwapKpiSlice = createSlice({
  name: "schedulingDropSwapKpi",
  initialState,
  reducers: {
    setDropRequestsKpi(state, action: PayloadAction<DropRequestKpi>) {
      state.drop = action.payload;
    },
    setSwapRequestsKpi(state, action: PayloadAction<SwapRequestKpi>) {
      state.swap = action.payload;
    },
  },
});

export const { setDropRequestsKpi, setSwapRequestsKpi } =
  schedulingDropSwapKpiSlice.actions;
export default schedulingDropSwapKpiSlice.reducer;
